import {} from './mutation-types'

export function paymentAccount(state) {
  return state.payments.account
}

export function paymentDefaultPaymentMethod(state) {
  return state.payments.paymentMethods.length ? state.payments.paymentMethods[0] : {}
}

export function paymentMemberSubscription(state) {
  return state.memberships.membership.subscription
}